import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const envPlugin = createPlugin({
  id: 'env',
  routes: {
    root: rootRouteRef,
  },
});

export const EnvPage = envPlugin.provide(
  createRoutableExtension({
    name: 'EnvPage',
    component: () => import('./components/AddEnv').then(m => m.AddEnv),
    mountPoint: rootRouteRef,
  }),
);
